export default {
  answerFourAction: "contact us.",
  answerFourSegment: "Not what you were looking for? No problem - just ",
  answerOne: (siteName: string): string =>
    `A premium subscription to ${siteName} gives you access to premium articles and exclusive team coverage, and membership to premium ${siteName} and Nationals forums, on the website and our mobile iOS and Android apps. You also get access to our exclusive FanFutureCast feature - FanFutureCast lets users predict where top recruits will end up playing. Try to outsmart the analysts and your fellow fans!`,
  answerThree: (siteName: string): string =>
    `Subscriptions to ${siteName} are billed either annually or monthly, and automatically renew at the end of the subscription period.`,
  answerTwo: "A free account gives you membership to all free forums.",
  moreFAQs: "View More FAQs",
  questionFour: "What if I want to cancel?",
  questionOne: (siteName: string): string =>
    `What will I get with a premium subscription to ${siteName}?`,
  questionThree: "How does the billing work?",
  questionTwo: "What will I get with a free account?",
  sectionTitle: "Have a question?"
};
